import { UserAuditLogEntry } from 'apis/auditLogs';

import { SummaryItems } from './summaryItems';
import { UserActivityCard } from './userActivityCard';
import { statusColors } from './userActivityTypes.utils';

type OrderCanceledProps = {
  entry: UserAuditLogEntry<'COMMERCE_ORDER_CANCELED'>;
};

export const OrderCanceled = ({ entry }: OrderCanceledProps): JSX.Element => (
  <UserActivityCard
    entry={entry}
    icon="ban"
    color={statusColors.negative}
    title="Order canceled"
    summary={
      <SummaryItems
        items={[
          {
            key: 'order',
            content: entry.order_id,
            copyText: entry.order_id,
            label: 'Order ID',
          },
          { key: 'reason', content: entry.reason },
        ]}
      />
    }
  />
);
